import { createFileRoute, useRouter } from '@tanstack/react-router'
import { useEffect } from 'react'

import useUser from '../lib/api/auth/me'

export const Route = createFileRoute('/')({
  component: Home,
})

function Home() {
  const router = useRouter()
  const { user, isPending } = useUser()

  useEffect(() => {
    if (!isPending) {
      if (user) {
        router.navigate({ to: '/dashboard/fleet-map' })
      } else {
        router.navigate({ to: '/login' })
      }
    }
  }, [user, isPending, router])

  return (
    <div className="flex h-screen items-center justify-center">
      <div className="text-center">
        <div className="border-primary mx-auto h-8 w-8 animate-spin rounded-full border-4 border-t-transparent" />
        <p className="text-muted-foreground mt-4">Loading...</p>
      </div>
    </div>
  )
}
